/* Shared material demonstration. Footage stays at its original speed and framing. */
(() => {
  'use strict';
  const pxConfig = () => {try{return JSON.parse(document.querySelector('[data-a6-product-config]').textContent)||{};}catch(_){return {};}};
  const pxAsset = name => pxConfig().assets?.[name]||'';
  const pxProduct = name => pxConfig().productUrls?.[name]||'/collections/all';


  const videoSource = pxAsset('bouncy-drop-test-v77.mp4');
  const posterSource = pxAsset('bouncy-drop-test-poster-v77.jpg');
  const descriptionsSource = pxAsset('bouncy-drop-test-v77.vtt');
  const models = {
    bouncy: { name: 'Bouncy', color: 'Green', reading: 'Follow the green sample. Bouncy brings a lively, springy response underfoot.' },
    embrace: { name: 'Embrace', color: 'Blue', reading: 'Follow the blue sample. Embrace pairs a softly contouring feel with a calmer, lower rebound.' },
    fusion: { name: 'Fusion', color: 'Two-tone', reading: 'Follow the two-tone sample. Fusion has a firmer cushioning feel with a more composed, less lively response.' },
    honeycomb: { name: 'HoneyComb', color: 'Yellow', reading: 'Follow the yellow sample. Watch its rebound, then inspect the surface shown after impact.' },
    plush: { name: 'Plush', color: 'Grey', reading: 'Follow the grey sample. Plush pairs soft contact with a springy return.' }
  };
  const bindings = new WeakMap();
  const playIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m9 5 10 7-10 7V5Z" fill="currentColor"/></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 5v14M16 5v14" stroke="currentColor" stroke-width="3"/></svg>';
  let sequence = 0;

  function render({ model } = {}) {
    const key = typeof model === 'string' ? model.toLowerCase() : '';
    const current = models[key];
    if (!current) return '';
    const id = `px-material-video-${++sequence}`;
    const legend = Object.entries(models).map(([modelKey, item]) => `<li data-px-material-legend="${modelKey}"${modelKey === key ? ' aria-current="true"' : ''}><span class="px-material-test__swatch" data-px-material-color="${modelKey}" aria-hidden="true"></span><span>${item.name}<span class="px-material-test__legend-color">${item.color}</span></span></li>`).join('');

    return `<div class="px-material-test" data-material-model="${key}">
      <figure class="px-material-test__player">
        <figcaption class="px-material-test__caption"><span class="px-material-test__current"><span class="px-material-test__swatch" data-px-material-color="${key}" aria-hidden="true"></span><strong>${current.name}</strong><span>${current.color} material</span></span><span class="px-material-test__recording">Real demonstration · Original speed</span></figcaption>
        <div class="px-material-test__screen">
          <video id="${id}" data-px-material-video controls playsinline muted preload="none" poster="${posterSource}" aria-label="Real material demonstration: EVA reference, five cushioning responses, and surface inspection" aria-describedby="${id}-reading">
            <source src="${videoSource}" type="video/mp4">
            <track kind="descriptions" src="${descriptionsSource}" srclang="en" label="Visual description">
            <p><a href="${videoSource}">Watch the material demonstration.</a></p>
          </video>
          <button type="button" class="px-material-test__start" data-px-material-start aria-controls="${id}" aria-label="Play material demonstration" hidden><span class="px-material-test__start-icon">${playIcon}</span><span data-px-material-start-label>Watch the material test</span></button>
        </div>
      </figure>
      <div class="px-material-test__controls">
        <button type="button" class="px-material-test__play" data-px-material-play aria-controls="${id}"><span data-px-material-play-label>Play comparison</span><span data-px-material-play-icon>${playIcon}</span></button>
        <div class="px-material-test__chapters" role="group" aria-label="Jump to a moment in the material demonstration"><button type="button" data-px-material-time="0" aria-controls="${id}" aria-pressed="true">EVA reference</button><button type="button" data-px-material-time="5.4" aria-controls="${id}" aria-pressed="false">Rebound responses</button><button type="button" data-px-material-time="12.7" aria-controls="${id}" aria-pressed="false">Surface check</button></div>
      </div>
      <p class="px-material-test__error" data-px-material-error role="status" hidden>The video could not play. <a href="${videoSource}">Open the demonstration directly.</a></p>
      <div class="px-material-test__context"><p class="px-material-test__reading" id="${id}-reading">${current.reading}</p><p class="px-material-test__principle">Different rebound.<br> Different feel.</p></div>
      <ul class="px-material-test__legend" aria-label="Materials shown in the demonstration, identified by color">${legend}</ul>
    </div>`;
  }

  function bind(component) {
    const video = component.querySelector('[data-px-material-video]');
    if (!video) return null;
    const start = component.querySelector('[data-px-material-start]');
    const startLabel = component.querySelector('[data-px-material-start-label]');
    const playLabel = component.querySelector('[data-px-material-play-label]');
    const playButtonIcon = component.querySelector('[data-px-material-play-icon]');
    const error = component.querySelector('[data-px-material-error]');
    const chapters = Array.from(component.querySelectorAll('[data-px-material-time]'));
    const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    let disposed = false;
    let pendingSeek = null;
    let seekGeneration = 0;
    let playRequest = 0;
    let observer = null;

    function cancelSeek() {
      seekGeneration += 1;
      if (!pendingSeek) return;
      video.removeEventListener('loadedmetadata', pendingSeek);
      pendingSeek = null;
    }

    function syncState() {
      const atStart = video.paused && video.currentTime === 0 && !video.ended;
      video.controls = !atStart && !video.ended;
      start.hidden = !atStart && !video.ended;
      start.setAttribute('aria-label', video.ended ? 'Replay material demonstration' : 'Play material demonstration');
      startLabel.textContent = video.ended ? 'Watch again' : 'Watch the material test';
      playLabel.textContent = video.ended ? 'Replay comparison' : video.paused ? 'Play comparison' : 'Pause comparison';
      playButtonIcon.innerHTML = video.paused ? playIcon : pauseIcon;
      component.dataset.materialState = video.ended ? 'ended' : video.paused ? 'paused' : 'playing';
    }

    function syncChapter() {
      const time = video.currentTime;
      const active = time >= 12.7 ? '12.7' : time >= 5.4 ? '5.4' : '0';
      chapters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pxMaterialTime === active)));
    }

    function pause() {
      playRequest += 1;
      cancelSeek();
      video.pause();
      if (!disposed) syncState();
    }

    function play() {
      if (disposed || document.hidden) return;
      const request = ++playRequest;
      error.hidden = true;
      video.playbackRate = 1;
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(reason => {
          if (!disposed && request === playRequest && reason?.name !== 'AbortError') error.hidden = false;
        });
      }
    }

    function seek(time) {
      if (disposed) return;
      cancelSeek();
      const generation = seekGeneration;
      const applySeek = () => {
        if (disposed || generation !== seekGeneration) return;
        pendingSeek = null;
        if (document.hidden) return;
        video.currentTime = Number.isFinite(video.duration) ? Math.min(time, video.duration) : time;
        syncChapter();
        play();
      };
      if (video.readyState >= 1) applySeek();
      else {
        pendingSeek = applySeek;
        video.addEventListener('loadedmetadata', applySeek, { once: true });
        video.load();
      }
    }

    function onClick(event) {
      const button = event.target.closest('button');
      if (!button || !component.contains(button)) return;
      if (button.matches('[data-px-material-time]')) {
        seek(Number(button.dataset.pxMaterialTime));
      } else if (button.matches('[data-px-material-play], [data-px-material-start]')) {
        cancelSeek();
        if (video.paused) {
          if (video.ended) video.currentTime = 0;
          play();
        } else pause();
      }
    }

    function onVisibility() { if (document.hidden) pause(); }
    function onMotionChange() { pause(); }
    function onError() { if (!disposed) error.hidden = false; }
    function onPlay() {
      if (disposed || document.hidden) { pause(); return; }
      syncState();
    }

    video.defaultPlaybackRate = 1;
    video.playbackRate = 1;
    component.addEventListener('click', onClick);
    document.addEventListener('visibilitychange', onVisibility);
    motion?.addEventListener?.('change', onMotionChange);
    video.addEventListener('play', onPlay);
    video.addEventListener('pause', syncState);
    video.addEventListener('ended', syncState);
    video.addEventListener('timeupdate', syncChapter);
    video.addEventListener('seeked', syncChapter);
    video.addEventListener('error', onError);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => !entry.isIntersecting)) pause();
      });
      observer.observe(video);
    }
    syncState();
    syncChapter();

    function destroy() {
      if (disposed) return;
      disposed = true;
      observer?.disconnect();
      component.removeEventListener('click', onClick);
      document.removeEventListener('visibilitychange', onVisibility);
      motion?.removeEventListener?.('change', onMotionChange);
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', syncState);
      video.removeEventListener('ended', syncState);
      video.removeEventListener('timeupdate', syncChapter);
      video.removeEventListener('seeked', syncChapter);
      video.removeEventListener('error', onError);
      pause();
      start.hidden = true;
      video.controls = true;
      delete component.dataset.materialState;
      bindings.delete(component);
    }
    bindings.set(component, { pause, destroy });
    return destroy;
  }

  function componentsWithin(root) {
    const components = root.matches?.('.px-material-test') ? [root] : [];
    components.push(...root.querySelectorAll('.px-material-test'));
    return components;
  }

  function pause(root = document) {
    componentsWithin(root).forEach(component => bindings.get(component)?.pause());
  }

  function init(root = document) {
    const cleanups = componentsWithin(root).filter(component => !bindings.has(component)).map(bind).filter(Boolean);
    return () => cleanups.forEach(cleanup => cleanup());
  }

  window.PXMaterialTest = { render, init, pause };
})();
